'use client'

import dynamic from 'next/dynamic'

export function EducdaySectionLoader({ template }: { template: string | null }) {
  const EducdaySection = dynamic(
    () =>
      import(`@/components/${template}/home/educday-section`).catch(() => {
        return Promise.resolve(() => null)
      }),
    { ssr: false }
  )

  return <EducdaySection />
}
